export default __webpack_public_path__ + "static/media/arrow-down.66ee6a8f.svg";